export const article = [
  {
    articleId: 31,
    url: "tus-cargos-del-servicio-de-mega-go",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "Tus cargos del servicio de Mega GO ",
    content: 
      <>
        <div className="rowLine">
          <h2>Ver tu plan y costo mensual </h2>
          <p>Inicia sesión en tu Cuenta y selecciona Detalles de facturación para ver tu plan de Mega GO y el historial de facturación.</p>
          <p>Puedes comparar planes y precios y cambiar tu plan en cualquier momento.</p>
        </div>
        <div className="rowLine">
          <h2>Comprende tu fecha de facturación </h2>
          <p>Como miembro, se te cobrará automáticamente una vez por mes en la fecha de suscripción. Tu suscripción de Mega GO se cobra al principio de cada periodo de facturación, pero la transacción podría aparecer en tu cuenta varios días después.</p> 
          <ul className="disc">
            <li>Es probable que tu fecha de facturación pueda adelantarse o atrasarse un día, debido a las diferencias entre zonas horarias. </li>
            <li>Si el día de tu fecha de facturación no existe en todos los meses (por ejemplo, el día 31), entonces la facturación tendrá lugar el último día de ese mes. </li>
          </ul>
        </div>
        <div>
          <h2>Actualiza tu información de pago</h2>
          <p>Inicia sesión en tu Cuenta y selecciona Administrar información de pago. Algunas opciones de pago te dirigirán a su sitio web para finalizar el proceso de actualización. </p>
          <p>Si deseas cambiar la forma en que pagas Mega GO, contamos con diversas opciones de pago.</p>
        </div>
      </>
  }
];